export default __webpack_public_path__ + "static/media/reward-popup-image.3b73733c.svg";